import { trackAffiliateClick } from "../../lib/track";

export default function AffiliateCTA({
  href,
  tool,
  slug,
  children = "Visit",
}) {
  if (!href) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="nofollow sponsored noopener noreferrer"
      className="affiliate-cta-btn"
      onClick={() =>
        trackAffiliateClick({
          tool,
          slug,
        })
      }
    >
      {children}
    </a>
  );
}